export const ThemeConstants = {
  HEADER_HEIGHT: 66,
  TASK_BUTTONS_CONTAINER_ID: "taskButtonsContainer",
  TASK_BUTTONS_CONTAINER_HEIGHT: 66,
  SIGNATURE_CANVAS_PROPS: {
    height: 240,
    style: { border: "1px solid gray" },
  },
};
